import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import {
  Btn,
  CustomCheckbox,
  CustomModal,
  InputNumeroInteiro,
  InputPhone,
  InputText,
} from '../../../../../components'
import useAjudanteModal, { LOAD_MESSAGE } from './AjudanteModalHook'

function AjudanteModal({ show, onModalClose, onModalSave, ajudante, selectedTp, dispatch }) {
  const { state, localDispatch } = useAjudanteModal()

  useEffect(() => {
    if (show) localDispatch.onInit(ajudante)
  }, [ajudante, show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.SAVE_ASSISTANT:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.saveAjudante(state.ajudante, selectedTp)
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave({ ...state.savedAjudante })
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetErrorMessage()
    }
  }, [state.errorMessage])

  return (
    <CustomModal header="Ajudante" isVisible={show} onClose={onModalClose} width={600}>
      <form className="p-grid">
        <div className="p-col-8">
          <InputText
            label="Nome:*"
            value={localDispatch.validateValue(state.ajudante.name)}
            onChange={value => localDispatch.onInputChange('name', value.toUpperCase())}
          />
        </div>
        <div className="p-col-4">
          <InputNumeroInteiro
            label="CPF:"
            value={localDispatch.validateValue(state.ajudante.cpf)}
            onChange={value => localDispatch.onInputChange('cpf', value)}
            format="###.###.###-##"
          />
        </div>
        <div className="p-col-4">
          <InputPhone
            marginTop={9}
            label="Telefone de Contato:"
            value={localDispatch.validateValue(state.ajudante.phone)}
            onChange={value => localDispatch.onInputChange('phone', value)}
          />
        </div>
        <div className="p-col-8">
          <InputText
            marginTop={9}
            label="Endereço:"
            value={localDispatch.validateValue(state.ajudante.address)}
            onChange={value => localDispatch.onInputChange('address', value.toUpperCase())}
          />
        </div>
        <div className="p-col-3" style={{ margin: 'auto 0' }}>
          <CustomCheckbox
            checked={state.ajudante.actived}
            onChange={value => localDispatch.onInputChange('actived', value)}
          >
            Ativo
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <Btn onClick={() => localDispatch.onBtnSalvarClicked(selectedTp)}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default connect()(AjudanteModal)

